import { useParams, useNavigate } from "react-router-dom";
import { ChevronLeft, CreditCard } from "lucide-react";

/**
 * Placeholder for agent event payment (buy ticket flow).
 * Replace with full payment flow when ready.
 */
export default function AgentEventPaymentPlaceholder() {
  const { slug } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="max-w-md w-full p-8 bg-white rounded-2xl border border-gray-200 shadow-lg text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 rounded-full bg-emerald-100 flex items-center justify-center">
            <CreditCard className="w-8 h-8 text-emerald-600" />
          </div>
        </div>
        <h1 className="text-xl font-bold text-gray-900 mb-2">Payment</h1>
        <p className="text-gray-600 mb-6">
          Complete your ticket purchase here. Payment integration coming soon.
        </p>
        <button
          type="button"
          onClick={() => navigate(`/event-media-sales/event-details/${slug}/book`)}
          className="inline-flex gap-2 items-center px-5 py-2.5 text-sm font-semibold text-white bg-emerald-600 rounded-lg hover:bg-emerald-700"
        >
          <ChevronLeft size={18} />
          Back to ticket selection
        </button>
      </div>
    </div>
  );
}
